import { render, staticRenderFns } from "./AmountDueByPeriodsReportForm.vue?vue&type=template&id=33571afa&"
import script from "./AmountDueByPeriodsReportForm.vue?vue&type=script&lang=js&"
export * from "./AmountDueByPeriodsReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports